"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatureImage = CreatureImage;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const creatureDefinitions_1 = require("~/networking/creatureDefinitions");
const useStyles = (0, react_jss_1.createUseStyles)({
    image: {
        width: "100%",
        height: "100%",
        imageRendering: "auto",
    },
});
function CreatureImage({ facing, definitionId, className }) {
    const classes = useStyles();
    const src = (0, creatureDefinitions_1.getCreatureImageUrl)(definitionId, facing || "front");
    if (!src) {
        return null;
    }
    return React.createElement("img", { className: (0, classnames_1.default)(classes.image, className), src: src });
}
